<script>
import HsSectionCard from "@/base/hs-tableview/hs-section/hs-section-card.vue";
import HsCheckbox from "@/base/hs-checkbox/hs-checkbox.vue";

export default {
  props: {
    value: {
      type: Boolean,
      default: null
    },
    currentDetails: {
      type: Object,
      default: () => {
        return {}
      }
    },
    OrderBusinessType: {
      type: Number,
      default: 0
    },
  },
  components: {
    HsCheckbox,
    HsSectionCard
  },
  methods: {
    _setIsReadAndAgree() {
      this.$emit("update:value", !this.value);
    }
  },
}
</script>

<template>
<div style="width: 100%;">
  <hs-section-card>
    <div class="details">
      <div class="passenger-des-title">
        <hs-checkbox
            :value="value"
            :title="$t('HsTravelerExplainTitle')"
            :checkboxLogo="['icons_16pt_selection-1.svg', 'icons_16pt_selection.svg']"
            style="margin-right: 30px"
            @click.native="_setIsReadAndAgree"
        ></hs-checkbox>
      </div>
      {{ $t("HsTravelerExplainContext") }}
    </div>
  </hs-section-card>

  <hs-section-card v-if="OrderBusinessType === 0 && currentDetails.index >= 0 && currentDetails.OperateButtonType === 2">
    <div class="details" style="padding: 12px 16px" @click="$emit('delete')">
      <div class="btn">{{$t('DeleteFrequentFlyer')}}</div>
    </div>
  </hs-section-card>
</div>
</template>

<style scoped lang="stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.details{
  @extend .hs-font-caption-1;
  width: 100%;
  color: $color_black_300;
  padding: 16px;
  .passenger-des-title {
    color: $color_black_70;
    margin-bottom: 8px;
    :deep(p) {
      @extend .hs-font-caption-1;
      color: $color_black_70;
    }
    :deep(.checkbox-outer-gender){
      margin-right: 4px;
    }
  }
  >.btn{
    @extend .flex-center;
    @extend .hs-font-body;
    width: 100%;
    color: $color_black_300;
  }
}
</style>
